/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-kno2
 * Kno2 Document Fetcher API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateKno2InfoRequest,
  GetDocuments200Response,
  GetKno2Info200Response,
  GetKno2Info404Response,
  GetLatestExecution404Response,
  ProcessDocumentsRequest,
  TriggerDocumentFetcher201Response,
  TriggerDocumentFetcherRequest,
} from '../models/index';
import {
    CreateKno2InfoRequestFromJSON,
    CreateKno2InfoRequestToJSON,
    GetDocuments200ResponseFromJSON,
    GetDocuments200ResponseToJSON,
    GetKno2Info200ResponseFromJSON,
    GetKno2Info200ResponseToJSON,
    GetKno2Info404ResponseFromJSON,
    GetKno2Info404ResponseToJSON,
    GetLatestExecution404ResponseFromJSON,
    GetLatestExecution404ResponseToJSON,
    ProcessDocumentsRequestFromJSON,
    ProcessDocumentsRequestToJSON,
    TriggerDocumentFetcher201ResponseFromJSON,
    TriggerDocumentFetcher201ResponseToJSON,
    TriggerDocumentFetcherRequestFromJSON,
    TriggerDocumentFetcherRequestToJSON,
} from '../models/index';

export interface CreateKno2InfoOperationRequest {
    leadId: string;
    createKno2InfoRequest: CreateKno2InfoRequest;
}

export interface GetDocumentsRequest {
    leadId: string;
}

export interface GetKno2InfoRequest {
    leadId: string;
}

export interface GetLatestExecutionRequest {
    leadId: string;
}

export interface ProcessDocumentsOperationRequest {
    leadId: string;
    processDocumentsRequest: ProcessDocumentsRequest;
}

export interface TriggerDocumentFetcherOperationRequest {
    leadId: string;
    triggerDocumentFetcherRequest: TriggerDocumentFetcherRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Create or update KNO2 info for a lead
     */
    async createKno2InfoRaw(requestParameters: CreateKno2InfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetKno2Info200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createKno2Info.');
        }

        if (requestParameters.createKno2InfoRequest === null || requestParameters.createKno2InfoRequest === undefined) {
            throw new runtime.RequiredError('createKno2InfoRequest','Required parameter requestParameters.createKno2InfoRequest was null or undefined when calling createKno2Info.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/kno2/leads/{lead_id}/info`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateKno2InfoRequestToJSON(requestParameters.createKno2InfoRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetKno2Info200ResponseFromJSON(jsonValue));
    }

    /**
     * Create or update KNO2 info for a lead
     */
    async createKno2Info(requestParameters: CreateKno2InfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetKno2Info200Response> {
        const response = await this.createKno2InfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get documents for a lead
     */
    async getDocumentsRaw(requestParameters: GetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDocuments200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getDocuments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/kno2/leads/{lead_id}/documents`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDocuments200ResponseFromJSON(jsonValue));
    }

    /**
     * Get documents for a lead
     */
    async getDocuments(requestParameters: GetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDocuments200Response> {
        const response = await this.getDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get KNO2 info for a lead
     */
    async getKno2InfoRaw(requestParameters: GetKno2InfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetKno2Info200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getKno2Info.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/kno2/leads/{lead_id}/info`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetKno2Info200ResponseFromJSON(jsonValue));
    }

    /**
     * Get KNO2 info for a lead
     */
    async getKno2Info(requestParameters: GetKno2InfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetKno2Info200Response> {
        const response = await this.getKno2InfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get latest execution status for a lead
     */
    async getLatestExecutionRaw(requestParameters: GetLatestExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TriggerDocumentFetcher201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getLatestExecution.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/kno2/leads/{lead_id}/execution`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TriggerDocumentFetcher201ResponseFromJSON(jsonValue));
    }

    /**
     * Get latest execution status for a lead
     */
    async getLatestExecution(requestParameters: GetLatestExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TriggerDocumentFetcher201Response> {
        const response = await this.getLatestExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Process selected documents for a lead
     */
    async processDocumentsRaw(requestParameters: ProcessDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling processDocuments.');
        }

        if (requestParameters.processDocumentsRequest === null || requestParameters.processDocumentsRequest === undefined) {
            throw new runtime.RequiredError('processDocumentsRequest','Required parameter requestParameters.processDocumentsRequest was null or undefined when calling processDocuments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/kno2/leads/{lead_id}/process-documents`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProcessDocumentsRequestToJSON(requestParameters.processDocumentsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Process selected documents for a lead
     */
    async processDocuments(requestParameters: ProcessDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.processDocumentsRaw(requestParameters, initOverrides);
    }

    /**
     * Trigger document fetcher for a lead
     */
    async triggerDocumentFetcherRaw(requestParameters: TriggerDocumentFetcherOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TriggerDocumentFetcher201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling triggerDocumentFetcher.');
        }

        if (requestParameters.triggerDocumentFetcherRequest === null || requestParameters.triggerDocumentFetcherRequest === undefined) {
            throw new runtime.RequiredError('triggerDocumentFetcherRequest','Required parameter requestParameters.triggerDocumentFetcherRequest was null or undefined when calling triggerDocumentFetcher.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/kno2/leads/{lead_id}/fetch-documents`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TriggerDocumentFetcherRequestToJSON(requestParameters.triggerDocumentFetcherRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TriggerDocumentFetcher201ResponseFromJSON(jsonValue));
    }

    /**
     * Trigger document fetcher for a lead
     */
    async triggerDocumentFetcher(requestParameters: TriggerDocumentFetcherOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TriggerDocumentFetcher201Response> {
        const response = await this.triggerDocumentFetcherRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
